import React from "react";

import { Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import Carrusel from "../Components/Carrusel";
import InfiniteCarrusel from "../Components/InfiniteCarrusel";
import FormContact from "../Components/FormContact";

import video from "../Videos/10.mp4";

import logo from "../Images/Logos/logo_premiaciones.png";
import logo_b from "../Images/Logos/logo_premiaciones_b.png";
import img9 from "../Images/9.png";
import img10 from "../Images/10.png";
import img11 from "../Images/11.png";

import icon1 from "../Images/Icons/1.svg";
import icon2 from "../Images/Icons/2.svg";

import img3 from "../Images/Logos/3.png";
import img4 from "../Images/Logos/4.png";
import img5 from "../Images/Logos/5.png";
import img6 from "../Images/Logos/6.png";

const Premiaciones = () => {
  return (
    <>
      <section>
        <video
          style={{ width: "100%" }}
          autoPlay
          muted
          playsInline
          id="myVideo"
          loop
        >
          <source src={video} type="video/mp4" />
        </video>
        <Container
          sx={{ textAlign: "center", maxWidth: { xs: "370px", sm: "lg" } }}
        >
          <h1 style={{ display: "none" }}>
            Premio a la trayectoriaen las gestiones de residuos
          </h1>
          <img
            src={logo}
            alt="Premio a la trayectoriaen las gestiones de residuos"
            className="img-principal"
          />
          <p className="texto-1">
            ¿Eres un <b>defensor</b> apasionado del medio ambiente?
          </p>
          <p className="texto-1">
            ¿Has desarrollado <b>soluciones innovadoras</b> para enfrentar{" "}
            <br />
            el desafío global de los residuos?
          </p>
          <p className="texto-1">
            <b>¡Esta es tu oportunidad de destacar!</b>
          </p>
        </Container>
      </section>

      <section
        style={{
          background: "#E2E4E4",
          marginTop: "40px",
          padding: "25px 0 30px 0",
        }}
      >
        <Container sx={{ maxWidth: { xs: "360px", sm: "lg" } }}>
          <Grid container spacing={4}>
            <Grid xs={12} sm={6} sx={{ order: { xs: 2, sm: 1 } }}>
              <p className="texto-2">
                <b style={{ color: "#2B465D" }}>
                  <img
                    alt="Visibilidad"
                    src={icon1}
                    style={{ width: "32px" }}
                  />
                  Visibilidad
                </b>
                Tu innovación será difundida a nivel nacional ofreciendo una
                plataforma única y especializada para darla a conocer como una
                buena práctica, ampliando tu red de contactos y posicionarte
                como líder en la gestión de residuos.
              </p>
              <p className="texto-2">
                <b style={{ color: "#2B465D" }}>
                  <img
                    alt="Visibilidad"
                    src={icon2}
                    style={{ width: "32px" }}
                  />
                  Impacto
                </b>
                Tu contribución ayudará a resolver uno de los mayores desafíos
                de nuestro tiempo, generando un impacto positivo en el medio
                ambiente y en la calidad de vida de las comunidades.
              </p>
            </Grid>
            <Grid
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                order: { xs: 1, sm: 2 },
              }}
            >
              <img
                style={{ width: "100%", borderRadius: "10px" }}
                src={img9}
                alt="Premio DS Latam"
              />
            </Grid>
          </Grid>
          <Grid
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              flexWrap: "wrap",
            }}
          >
            <img
              src={img3}
              style={{ maxWidth: "368px", width: "100%" }}
              alt="Logo DS Latam - ISWA"
            />
            <img
              src={img4}
              style={{ maxWidth: "207px", width: "100%" }}
              alt="Logo ISWA - LAC"
            />
            <img
              src={img5}
              style={{ maxWidth: "193px", width: "100%" }}
              alt="Logo CECC"
            />
            <img
              src={img6}
              style={{ maxWidth: "169px", width: "100%" }}
              alt="Logo ategruss"
            />
          </Grid>
        </Container>
      </section>

      <section>
        <Container sx={{ maxWidth: { xs: "360px", sm: "lg" } }}>
          <h2 className="titulo-1">
            Descripción <b>del Premio</b>
          </h2>
          <Grid container spacing={4}>
            <Grid
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "100%", borderRadius: "10px" }}
                src={img10}
                alt="Premiados DS Latam"
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <p className="texto-3">
                DS LATAM ISWA MÉXICO, Asociación de Profesionales en Residuos,
                Miembro Nacional de México para la International Solid Waste
                Association (ISWA), te invita a la tercera edición del 
                "<b>Premio a la Trayectoria en la Gestión de Residuos® 2026</b>",
                que se celebrará en el marco del Congreso Internacional de 
                Residuos el día 4 de marzo de 2026 durante la Residuos Expo 
                en el Centro CitiBanamex de la Ciudad de México.
              </p>
              <p className="texto-3">
                Este galardón reconoce, difunde y premia las mejores prácticas
                en proyectos, publicaciones, infraestructura, desarrollo
                tecnológico, y la gestión integral de residuos sólidos en
                México. Es una oportunidad para destacar los avances públicos y
                privados en la prevención y manejo de residuos.
              </p>
              <p className="texto-3">
                Las instituciones públicas y privadas de cualquier país de
                Latinoamérica están invitadas a participar en cualquiera de las
                categorías.
              </p>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section
        style={{
          background: "#E2E4E4",
          margin: "40px 0",
          padding: "25px 0 30px 0",
        }}
      >
        <Container
          sx={{
            textAlign: { xs: "left", sm: "center" },
            maxWidth: { xs: "360px", sm: "lg" },
          }}
        >
          <Typography
            variant="h2"
            component="h2"
            className="titulo-1"
            sx={{
              lineHeight: { xs: "25px", sm: "68px" },
              // letterSpacing: "-2.1px",
            }}
          >
            <b>Conoce a los ganadores</b>
            <br />
            <span>del Premio a la Trayectoria en la Gestión de Residuos</span>
          </Typography>
          <p className="texto-3">
            Descubre a los visionarios que transformaron la gestión de residuos
            en México y Latinoamérica.
          </p>
          <p className="texto-3">
            Los ganadores del año anterior fueron reconocidos por sus
            innovadoras soluciones y su impacto positivo
            <br />
            en el medio ambiente. Estos profesionales, municipios y empresas han
            marcado la diferencia con proyectos ejemplares,
            <br />
            promoviendo prácticas sostenibles y mejorando la calidad de vida en
            sus comunidades.
          </p>
          <p className="texto-3">
            Su dedicación y liderazgo los han convertido en referentes del
            sector, impulsando el cambio
            <br />
            hacia un futuro más sustentable.
          </p>
          <p className="texto-1">
            <b>¡Inspírate con sus historias!</b>
          </p>
        </Container>

        <Carrusel />
      </section>

      <section>
        <Container
          sx={{
            marginTop: { xs: "65px", sm: "0" },
            maxWidth: { xs: "360px", sm: "lg" },
          }}
        >
          <Grid container spacing={4}>
            <Grid xs={12} sm={6} sx={{ textAlign: "center" }}>
              <Typography
                variant="p"
                component="p"
                className="texto-4"
                sx={{
                  lineHeight: { xs: "25px", sm: "50px" },
                  marginBottom: "0",
                }}
              >
                <b>
                  “Este acontecimiento es un espacio para dar a conocer tu
                  innovación y experiencia en el manejo de residuos sólidos”
                </b>
              </Typography>
              <Typography
                variant="p"
                component="p"
                className="texto-4"
                sx={{
                  lineHeight: { xs: "25px", sm: "20px" },
                  marginTop: "0",
                }}
              >
                <span>
                  - <b>Francisco Galván Meraz</b> <br />
                  Presidente DS LATAM ISWA MÉXICO
                </span>
              </Typography>
            </Grid>
            <Grid
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "100%", borderRadius: "10px" }}
                src={img11}
                alt="Premio DS Latam"
              />
            </Grid>
          </Grid>
        </Container>
      </section>

      <section
        style={{
          backgroundColor: "#2B455E",
          paddingBottom: "45px",
          marginTop: "25px",
        }}
      >
        <Container sx={{ maxWidth: { xs: "360px", sm: "lg" } }}>
          <img
            src={logo_b}
            alt="Premio a la trayectoriaen las gestiones de residuos"
            style={{ width: "100%" }}
          />
        </Container>

        <InfiniteCarrusel />

        <Container
          sx={{
            textAlign: { xs: "left", sm: "center" },
            maxWidth: { xs: "360px", sm: "lg" },
          }}
        >
          <h2 className="texto-4" style={{ color: "#ffffff" }}>
            <b>Registra tu proyecto</b> y sé parte del cambio
          </h2>
          <p className="texto-3" style={{ color: "#ffffff" }}>
            Al completar este breve registro, serás redirigido automáticamente a
            las bases completas <br />
            para participar en la premiación.
          </p>
          <p className="texto-3" style={{ color: "#ffffff" }}>
            Ahí encontrarás la información necesaria sobre los requisitos,
            plazos y criterios de evaluación <br />
            para que puedas presentar tu proyecto con éxito.
          </p>
          <p
            className="texto-3"
            style={{ color: "#ffffff", textAlign: "center" }}
          >
            <b>
              ¡No pierdas la oportunidad de destacar tus logros y ser parte del
              cambio en la gestión de residuos!
            </b>
          </p>
        </Container>

        <Container
          id="premiacion"
          style={{ scrollMarginTop: "200px" }}
          sx={{ maxWidth: { xs: "360px", sm: "lg" } }}
        >
          <FormContact />
        </Container>
      </section>
    </>
  );
};

export default Premiaciones;
